/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Button, Modal, TableProps, Tag } from 'antd';
import TableComponent from '../table';
import {
  ISearchStockMovementReq,
  ISearchStockMovementRes,
  IStockMovement,
} from '@/interfaces/stock';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { searchStockMovements } from '@/adapters/stock';
import { twMerge } from 'tailwind-merge';
import {
  getStockMovementStatusColor,
  getStockMovementStatusName,
} from '@/helpers/stockHelper';
import { formatDate, formatNumber } from '@/utils/dataUtils';
interface IProps {
  stockId: number;
  productId?: number;
  lotNumber?: string;
  open: boolean;
  handleCancel: () => void;
}

const _criteria: ISearchStockMovementReq = {
  orderBy: 'id',
  orderType: 'descend',
  pageSize: -1,
  pageStart: 1,
  search: '',
  stockId: 0,
};

const StockMovementModal = ({
  open,
  handleCancel,
  stockId,
  lotNumber,
  productId,
}: IProps) => {
  const [criteria] = useState<ISearchStockMovementReq>({
    ..._criteria,
    stockId: stockId,
    lotNumber: lotNumber,
    productId: productId,
  });

  const columns: TableProps<IStockMovement>['columns'] = [
    {
      title: 'วันที่',
      dataIndex: 'movementDate',
      key: 'movementDate',
      className: 'font-medium',
      align: 'center',
      render: _ => {
        return formatDate(_);
      },
      width: 100,
    },
    {
      title: 'Lot No.',
      dataIndex: 'lotNumber',
      key: 'lotNumber',
      className: 'font-medium',
      align: 'center',
      width: 120,
    },
    {
      title: 'รหัสสินค้า',
      dataIndex: 'productCode',
      key: 'productCode',
      className: 'font-medium',
      align: 'center',
      width: 130,
    },
    {
      title: 'สินค้า',
      dataIndex: 'productName',
      key: 'productName',
      className: 'font-medium',
    },
    {
      title: 'ประเภท',
      dataIndex: 'movementType',
      key: 'movementType',
      className: 'font-medium',
      align: 'center',
      width: 80,
      render: _ => {
        const name = getStockMovementStatusName(_);
        const status = getStockMovementStatusColor(_);
        return <Tag className={twMerge(status?.bg, status?.text)}>{name}</Tag>;
      },
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      key: 'quantity',
      className: 'font-medium',
      align: 'right',
      width: 100,
      render: _ => {
        return formatNumber(_);
      },
    },
    {
      title: 'Reference',
      dataIndex: 'referenceNo',
      key: 'referenceNo',
      className: 'text-xs',
      render: (_, rec) => (
        <div className="flex flex-col gap-1">
          <div
            className="text-blue-700 underline underline-offset-2 cursor-pointer"
            onClick={() =>
              rec.referenceId
                ? window.open(`/order/${rec.referenceId}`, '_blank')
                : undefined
            }
          >
            {rec.refCustomerCode &&
              `Order: ${rec.referenceNo || ''}, IvNo: ${rec.refIvNo || ''}`}
          </div>
          <div>
            {rec.refCustomerCode &&
              `${rec.refCustomerCode || ''} - ${rec.refCustomerName || ''}`}
          </div>
          {!rec.referenceId && !rec.refCustomerCode && rec.referenceNo}
        </div>
      ),
    },
    {
      title: 'คงเหลือ',
      dataIndex: 'remain',
      key: 'remain',
      className: 'font-medium',
      align: 'right',
      width: 100,
      render: (_, rec) => {
        return formatNumber((rec.previousQuantity ?? 0) + rec.quantity);
      },
    },
    {
      title: 'สร้างโดย',
      dataIndex: 'createByName',
      key: 'createByName',
      className: 'font-medium',
      width: 100,
    },
  ];

  const { data: stockMovement, isLoading } = useQuery<
    AxiosResponse<ISearchStockMovementRes>,
    Error
  >({
    queryKey: ['search-stock-movement', criteria],
    queryFn: async () => await searchStockMovements(criteria),
  });

  return (
    <Modal
      title="Stock Movement"
      open={open}
      width={'1200px'}
      onCancel={handleCancel}
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
      ]}
    >
      <div className="flex flex-col gap-3 w-full">
        <TableComponent<IStockMovement>
          columns={columns}
          criteria={{}}
          data={stockMovement?.data || ({} as ISearchStockMovementRes)}
          loading={isLoading}
          onTableChange={() => console.log()}
          showPagination={false}
          scrollLength={800}
        />
      </div>
    </Modal>
  );
};

export default StockMovementModal;
